<script setup lang="ts">
import { isAuction, type SaleItemEntity } from '~/types/sale.type';

// PROPS
const { sale } = defineProps({
    sale: { type: Object as PropType<SaleItemEntity>, required: true },
    embedded: { type: Boolean, default: false },
});

// COMPOSABLES
const { statusSectionColor, isSeller } = isAuction(sale) ? useAuctionStatus(toRef(() => sale)) : useDirectSaleStatus(toRef(() => sale));
</script>

<template>
    <div class="divide-y divide-solid divide-neutral-200" :class="{ 'overflow-hidden rounded-xl border border-solid border-neutral-200': !embedded }">
        <div class="p-4 lg:p-6" :class="statusSectionColor">
            <SdpSalePanelStatusSection :sale="sale" />
        </div>

        <AdpSalePanelPlaceBidSection v-if="isAuction(sale)" :auction="sale" />
        <DsdpSalePanelActionsSection v-else :direct-sale="sale" />
        <SdpSalePanelVas v-if="!isSeller" :sale="sale" />
        <SdpSalePanelOrderSection />
    </div>
</template>
